import React from 'react';
import { useRefState } from 'src/shared/hooks/useRefState';
import { ScreenWidth, ScreenWidthValues } from 'web-common/src/shared/Constants';
import { Divider } from './Divider';
import { useCarousel } from './hooks';
import { DefaultContainer, PositionedScrollButtons } from './styles';
import { CarouselProps } from './types';

export const Carousel: React.FC<React.PropsWithChildren<CarouselProps>> = (props) => {
  const {
    children,
    ContainerComponent,
    scrollButtonsElementName = '',
    showScrollButtons = false,
    showMobileDivider = false,
    ...useCarouselProps
  } = props;

  const [ref, setRef] = useRefState<HTMLDivElement>();
  const [dividerRef, setDividerRef] = useRefState<HTMLDivElement>();
  const { hasOverflow, numElementsLeft, numElementsRight, scrollLeft, scrollRight, width } = useCarousel({
    ...useCarouselProps,
    dividerRef,
    ref,
  });
  const Container = ContainerComponent ?? DefaultContainer;

  return (
    <>
      <Container ref={setRef}>{children}</Container>
      {showScrollButtons && width > ScreenWidthValues[ScreenWidth.MEDIUM] && hasOverflow && (
        <PositionedScrollButtons
          elementName={scrollButtonsElementName}
          scrollRight={scrollRight}
          scrollLeft={scrollLeft}
          numElementsLeft={numElementsLeft}
          numElementsRight={numElementsRight}
        />
      )}
      {showMobileDivider && width <= ScreenWidthValues[ScreenWidth.SMALL] && <Divider ref={setDividerRef} />}
    </>
  );
};
